// extracted by mini-css-extract-plugin
export default {"ap-form-input":"Form_ap-form-input__9LB4o","ap-optional-label":"Form_ap-optional-label__bRxAE"};